<template>

    <header class="z-40" :class="{ dark: store.semidark && store.menu === 'horizontal' }">
        <div class="shadow-sm">
            <div class="relative bg-white flex w-full items-center px-7 lg:px-9 py-1.5 lg:py-2.5 dark:bg-[#0e1726]">
                <!-- Mobile Header Layout - Logo Centered -->
                <div class="horizontal-logo flex lg:hidden w-full items-center relative">
                    <!-- Hamburger Menu - Positioned Left -->
                    <a
                        href="javascript:;"
                        class="collapse-icon flex-none dark:text-[#d0d2d6] hover:text-primary dark:hover:text-primary p-2 rounded-full bg-white-light/40 dark:bg-dark/40 hover:bg-white-light/90 dark:hover:bg-dark/60 absolute ltr:left-0 rtl:right-0 z-10"
                        @click="store.toggleSidebar()"
                    >
                        <icon-menu class="w-5 h-5" />
                    </a>

                    <!-- Logo - Centered -->
                    <div class="flex-1 flex justify-center">
                        <router-link to="/" class="main-logo flex items-center">
                            <logo text-color="text-black"/>
                        </router-link>
                    </div>
                </div>

                <!-- Desktop Menu -->
                <div class="hidden lg:block">
                    <Menubar :model="items" class="!border-0">
                        <template #submenuicon="item">
                            <span class="pi pi-plus"></span>
                        </template>
                    </Menubar>
                </div>
            </div>
        </div>
    </header>

    <!-- Add a Customer Order -->
    <TransitionRoot appear :show="store.showAddCustomerOrder" as="template">
        <Dialog as="div" @close="store.showAddCustomerOrder = false" class="relative z-[51]">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0"
                             enter-to="opacity-100" leave="duration-200 ease-in"
                             leave-from="opacity-100"
                             leave-to="opacity-0">
                <DialogOverlay class="fixed inset-0 bg-[black]/60" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center px-4 py-8">
                    <TransitionChild as="template" enter="duration-300 ease-out"
                                     enter-from="opacity-0 scale-95"
                                     enter-to="opacity-100 scale-100"
                                     leave="duration-200 ease-in" leave-from="opacity-100 scale-100"
                                     leave-to="opacity-0 scale-95">
                        <DialogPanel
                            class="panel border-0 p-0 rounded-lg overflow-hidden w-full max-w-xl text-black dark:text-white-dark">
                            <button type="button"
                                    class="absolute top-4 ltr:right-4 rtl:left-4 text-gray-400 hover:text-gray-800 dark:hover:text-gray-600 outline-none"
                                    @click="store.showAddCustomerOrder = false">
                                <icon-x />
                            </button>
                            <div
                                class=" font-tajawal font-semibold text-lg bg-[#fbfbfb] dark:bg-[#121c2c] ltr:pl-5 rtl:pr-5 py-3 ltr:pr-[50px] rtl:pl-[50px]">
                                إضافة جديد - معاملات الزبائن
                            </div>

                            <div class="p-4 sm:p-6">
                                <div v-if="store.showInnerLoader"
                                     class="absolute inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                                    <icon-inside-loader />
                                </div>

                                <div class="grid grid-cols-2 gap-3 sm:gap-4 max-w-xl mx-auto">
                                    <!-- بطاقة بيع جديد -->
                                    <router-link to="/customers/add/sales_new">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <NewGold class="w-20 mb-2" />
                                            <span
                                                class="text-primary font-tajawal font-semibold text-base sm:text-lg group-hover:text-red-500 text-nowrap">بيع جديد</span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة شراء كسر -->
                                    <router-link to="/customers/add/purchases_old">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <SellBroken class="w-20 mb-2" />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">شراء
                                                                    كسر</span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة بيع كسر -->
                                    <router-link to="/customers/add/sales_old">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <BuyBroken class="w-20 mb-2" />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">بيع
                                                                    كسر</span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة عربون -->
                                    <router-link to="/customers/add/sales_deposit">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <Arboon class="w-20 mb-2" />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">عربون</span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة سداد -->
                                    <router-link to="/customers/add/sales_collection">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <Sadad class="w-20 mb-2" />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">سداد</span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة استكمال -->
                                    <router-link to="/customers/arboon">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <ContinueArboon class="w-20 mb-2" />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                استكمال بيع عربون
                                            </span>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>

    <!-- Add a Merchant Order -->
    <TransitionRoot appear :show="store.showAddMerchantOrder" as="template">
        <Dialog as="div" @close="store.showAddMerchantOrder = false" class="relative z-[51]">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0"
                             enter-to="opacity-100" leave="duration-200 ease-in"
                             leave-from="opacity-100"
                             leave-to="opacity-0">
                <DialogOverlay class="fixed inset-0 bg-[black]/60" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center px-4 py-8">
                    <TransitionChild as="template" enter="duration-300 ease-out"
                                     enter-from="opacity-0 scale-95"
                                     enter-to="opacity-100 scale-100"
                                     leave="duration-200 ease-in" leave-from="opacity-100 scale-100"
                                     leave-to="opacity-0 scale-95">
                        <DialogPanel
                            class="panel border-0 p-0 rounded-lg overflow-hidden w-full max-w-xl text-black dark:text-white-dark">
                            <button type="button"
                                    class="absolute top-4 ltr:right-4 rtl:left-4 text-gray-400 hover:text-gray-800 dark:hover:text-gray-600 outline-none"
                                    @click="store.showAddMerchantOrder = false">
                                <icon-x />
                            </button>
                            <div
                                class=" font-tajawal font-semibold text-lg bg-[#fbfbfb] dark:bg-[#121c2c] ltr:pl-5 rtl:pr-5 py-3 ltr:pr-[50px] rtl:pl-[50px]">
                                إضافة جديد - معاملات التجار
                            </div>

                            <div class="p-4 sm:p-6">
                                <div v-if="store.showInnerLoader"
                                     class="absolute inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                                    <icon-inside-loader />
                                </div>

                                <div class="grid grid-cols-2 gap-3 sm:gap-4 max-w-xl mx-auto">
                                    <!-- بطاقة بيع جديد -->
                                    <router-link to="/merchants/add/sales?gold_type=new">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <Sell />
                                            <span
                                                class="text-primary font-tajawal font-semibold text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                بيع جديد
                                            </span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة شراء جديد -->
                                    <router-link to="/merchants/add/purchases?gold_type=new">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <Buy />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                شراء جديد
                                            </span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة بيع كسر -->
                                    <router-link to="/merchants/add/sales?gold_type=old">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <BuyBroken />
                                            <span
                                                class="text-primary font-tajawal font-semibold text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                بيع كسر
                                            </span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة شراء كسر -->
                                    <router-link to="/merchants/add/purchases?gold_type=old">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <SellBroken />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                شراء كسر
                                            </span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة تحصيل بيع -->
                                    <router-link to="/merchants/add/sales_collection">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <Tahseel />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                تحصيل بيع
                                            </span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة سداد -->
                                    <router-link to="/merchants/add/purchases_payment">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <Sadad />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                سداد مشتريات
                                            </span>
                                        </div>
                                    </router-link>

                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>

    <!-- Add an Other Order -->
    <TransitionRoot appear :show="store.showAddOtherOrder" as="template">
        <Dialog as="div" @close="store.showAddOtherOrder = false" class="relative z-[51]">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0"
                             enter-to="opacity-100" leave="duration-200 ease-in"
                             leave-from="opacity-100"
                             leave-to="opacity-0">
                <DialogOverlay class="fixed inset-0 bg-[black]/60" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center px-4 py-8">
                    <TransitionChild as="template" enter="duration-300 ease-out"
                                     enter-from="opacity-0 scale-95"
                                     enter-to="opacity-100 scale-100"
                                     leave="duration-200 ease-in" leave-from="opacity-100 scale-100"
                                     leave-to="opacity-0 scale-95">
                        <DialogPanel
                            class="panel border-0 p-0 rounded-lg overflow-hidden w-full max-w-xl text-black dark:text-white-dark">
                            <button type="button"
                                    class="absolute top-4 ltr:right-4 rtl:left-4 text-gray-400 hover:text-gray-800 dark:hover:text-gray-600 outline-none"
                                    @click="store.showAddOtherOrder = false">
                                <icon-x />
                            </button>
                            <div
                                class=" font-tajawal font-semibold text-lg bg-[#fbfbfb] dark:bg-[#121c2c] ltr:pl-5 rtl:pr-5 py-3 ltr:pr-[50px] rtl:pl-[50px]">
                                إضافة جديد - معاملات أخرى
                            </div>

                            <div class="p-4 sm:p-6">
                                <div v-if="store.showInnerLoader"
                                     class="absolute inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                                    <icon-inside-loader />
                                </div>

                                <div class="grid grid-cols-2 gap-3 sm:gap-4 max-w-xl mx-auto">
                                    <!-- بطاقة تحويل عملات -->
                                    <router-link
                                        v-if="authStore.can('other_orders_currency_exchange')"
                                        to="/other/add?order_type=currency_exchange">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <convert-curr class="w-20 mb-2" />
                                            <span
                                                class="text-primary font-tajawal font-semibold text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                تحويل عملات
                                            </span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة مطابقة وزن -->
                                    <router-link
                                        v-if="authStore.can('other_orders_match_weights')"
                                        to="/other/add?order_type=match_weights">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <motabaka class="w-20 mb-2" />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                مطابقة وزن
                                            </span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة مصاريف -->
                                    <router-link
                                        v-if="authStore.can('other_orders_expenses')"
                                        to="/other/add?order_type=expenses">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <masareef class="w-20 mb-2" />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                مصاريف
                                            </span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة تعديل الصندوق -->
                                    <router-link
                                        v-if="authStore.can('other_orders_set_cash_balance')"
                                        to="/other/add?order_type=set_cash_balance">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <edit-box class="w-20 mb-2" />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                تعديل صندوق
                                            </span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة تحويل ذهب -->
                                    <router-link
                                        v-if="authStore.can('other_orders_convert_gold_type')"
                                        to="/other/add?order_type=convert_gold_type">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <convert-gold class="w-20 mb-2" />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">
                                                تحويل ذهب
                                            </span>
                                        </div>
                                    </router-link>

                                </div>
                            </div>

                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>

    <!-- Add a branch Order -->
    <TransitionRoot appear :show="store.showAddBranchOrder" as="template">
        <Dialog as="div" @close="store.showAddBranchOrder = false" class="relative z-[51]">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0"
                             enter-to="opacity-100" leave="duration-200 ease-in"
                             leave-from="opacity-100"
                             leave-to="opacity-0">
                <DialogOverlay class="fixed inset-0 bg-[black]/60" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center px-4 py-8">
                    <TransitionChild as="template" enter="duration-300 ease-out"
                                     enter-from="opacity-0 scale-95"
                                     enter-to="opacity-100 scale-100"
                                     leave="duration-200 ease-in" leave-from="opacity-100 scale-100"
                                     leave-to="opacity-0 scale-95">
                        <DialogPanel
                            class="panel border-0 p-0 rounded-lg overflow-hidden w-full max-w-xl text-black dark:text-white-dark">
                            <button type="button"
                                    class="absolute top-4 ltr:right-4 rtl:left-4 text-gray-400 hover:text-gray-800 dark:hover:text-gray-600 outline-none"
                                    @click="store.showAddBranchOrder = false">
                                <icon-x />
                            </button>
                            <div
                                class=" font-tajawal font-semibold text-lg bg-[#fbfbfb] dark:bg-[#121c2c] ltr:pl-5 rtl:pr-5 py-3 ltr:pr-[50px] rtl:pl-[50px]">
                                إضافة جديد - معاملات الفروع
                            </div>

                            <div class="p-4 sm:p-6">
                                <div v-if="store.showInnerLoader"
                                     class="absolute inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                                    <icon-inside-loader />
                                </div>

                                <div class="grid grid-cols-2 gap-3 sm:gap-4 max-w-xl mx-auto">
                                    <!-- بطاقة إرسال  -->
                                    <router-link to="/branches/add?order_type=send">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <send />
                                            <span
                                                class="text-primary font-tajawal font-semibold text-base sm:text-lg group-hover:text-red-500 text-nowrap">إرسال
                                                                </span>
                                        </div>
                                    </router-link>
                                    <!-- بطاقة إستقبال  -->
                                    <router-link to="/branches/add?order_type=receive">
                                        <div
                                            class="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md border hover:bg-gray-100 hover:shadow-sm transition duration-100 group">
                                            <revceive />
                                            <span
                                                class="text-primary font-semibold font-tajawal text-base sm:text-lg group-hover:text-red-500 text-nowrap">إستقبال
                                                                </span>
                                        </div>
                                    </router-link>

                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>

    <!-- Add a Customer/Trader -->
    <TransitionRoot appear :show="store.showAddCustomer !== null" as="template">
        <Dialog as="div" @close="store.closeAddNewCustomer" class="relative z-[51]">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0"
                             enter-to="opacity-100" leave="duration-200 ease-in"
                             leave-from="opacity-100"
                             leave-to="opacity-0">
                <DialogOverlay class="fixed inset-0 bg-[black]/60" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center px-4 py-8">
                    <TransitionChild as="template" enter="duration-300 ease-out"
                                     enter-from="opacity-0 scale-95"
                                     enter-to="opacity-100 scale-100"
                                     leave="duration-200 ease-in" leave-from="opacity-100 scale-100"
                                     leave-to="opacity-0 scale-95">

                        <add-new-customer :type="store.showAddCustomer"
                                          :data="store.editCustomerData"
                                          :show-other-type="false"
                                          @close="store.closeAddNewCustomer" />
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script lang="ts" setup>

    import { computed, ref } from 'vue';
    import { useAppStore } from '@/stores/index';

    import IconMenu from '@/components/icon/icon-menu.vue';
    import { Dialog, DialogOverlay, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
    import SellBroken from '@/components/icon/gold-popups/sell-broken.vue';
    import BuyBroken from '@/components/icon/gold-popups/buy-broken.vue';
    import IconX from '@/components/icon/icon-x.vue';
    import Arboon from '@/components/icon/gold-popups/arboon.vue';
    import NewGold from '@/components/icon/gold-popups/new-gold.vue';
    import Sadad from '@/components/icon/gold-popups/sadad.vue';
    import IconInsideLoader from '@/components/icon/icon-inside-loader.vue';
    import ContinueArboon from '@/components/icon/gold-popups/continue-arboon.vue';
    import Sell from '@/components/icon/gold-popups/merchant/sell.vue';
    import Tahseel from '@/components/icon/gold-popups/merchant/tahseel.vue';
    import Buy from '@/components/icon/gold-popups/merchant/buy.vue';
    import ConvertGold from '@/components/icon/gold-popups/other/convert-gold.vue';
    import EditBox from '@/components/icon/gold-popups/other/edit-box.vue';
    import Masareef from '@/components/icon/gold-popups/other/masareef.vue';
    import Motabaka from '@/components/icon/gold-popups/other/motabaka.vue';
    import ConvertCurr from '@/components/icon/gold-popups/other/convert-curr.vue';
    import Send from '@/components/icon/gold-popups/branches/send.vue';
    import Revceive from '@/components/icon/gold-popups/branches/revceive.vue';
    import AddNewCustomer from '@/views/admin-conf/comp/add-new-customer.vue';
    import { useRouter } from 'vue-router';
    import { useAuthStore } from '@/stores/auth';
    import Logo from "@/components/logo.vue";

    const store = useAppStore();
    const authStore = useAuthStore();
    const router = useRouter();

    const extraMenuItems = [
        authStore.can('trader_orders') && {
            key: 'add_trader_order',
            label: 'إضافة حركة تاجر',
            icon: 'pi pi-plus-circle',
            command: () => store.showAddMerchantOrder = true
        },
        authStore.can('branch_transfers') && {
            key: 'add_branch_order',
            label: 'إضافة حركة فرع',
            icon: 'pi pi-plus-circle',
            command: () => store.showAddBranchOrder = true
        },
        authStore.canAny(['other_orders_currency_exchange', 'other_orders_match_weights', 'other_orders_expenses', 'other_orders_set_cash_balance', 'other_orders_convert_gold_type']) && {
            key: 'add_other_order',
            label: 'إضافة حركات اخرى',
            icon: 'pi pi-plus-circle',
            command: () => store.showAddOtherOrder = true
        },
        {
            key: 'add_customer',
            label: 'إضافة زبون',
            icon: 'pi pi-user-plus',
            command: () => store.showAddCustomer = 'customers'
        },
        {
            key: 'add_trader',
            label: 'إضافة تاجر',
            icon: 'pi pi-user-plus',
            command: () => store.showAddCustomer = 'traders'
        },
        {
            key: 'add_prices',
            label: 'تغيير الاسعار',
            icon: 'pi pi-money-bill',
            command: () => router.push('/currencies/prices')
        },
        {
            key: 'add_balances',
            label: 'الارصدة',
            icon: 'pi pi-briefcase',
            command: () => router.push('/currencies/balances-list')
        },
        {
            key: 'add_sign_out',
            label: 'تسجيل الخروج',
            icon: 'pi pi-sign-out',
            command: () => authStore.logout()
        }
    ].filter(i => i);

    const extraMenuItemsAdded = computed(() => {
        return store.navbarButtons.map(key => extraMenuItems.find((item) => item.key === key)).filter(i => i);
    });

    const items = computed(() => [
        authStore.can('customer_orders') && {
            label: 'إضافة حركة زبائن',
            icon: 'pi pi-plus-circle',
            command: () => store.showAddCustomerOrder = true
        },
        ...extraMenuItemsAdded.value,
        {
            // label: 'إضافة للقائمة',
            // icon: 'pi pi-plus',
            class: 'menu_add_item',
            items: [
                authStore.can('trader_orders') && {
                    label: 'إضافة حركة تاجر',
                    icon: 'pi pi-plus-circle',
                    class: extraMenuItemsAdded.value.find(i => i.key === 'add_trader_order') ? 'selected' : '',
                    command: () => addItemToNav('add_trader_order')
                },
                authStore.can('branch_transfers') && {
                    label: 'إضافة حركة فرع',
                    icon: 'pi pi-plus-circle',
                    class: extraMenuItemsAdded.value.find(i => i.key === 'add_branch_order') ? 'selected' : '',
                    command: () => addItemToNav('add_branch_order')
                },
                authStore.canAny(['other_orders_currency_exchange', 'other_orders_match_weights', 'other_orders_expenses', 'other_orders_set_cash_balance', 'other_orders_convert_gold_type']) && {
                    label: 'إضافة حركات اخرى',
                    icon: 'pi pi-plus-circle',
                    class: extraMenuItemsAdded.value.find(i => i.key === 'add_other_order') ? 'selected' : '',
                    command: () => addItemToNav('add_other_order')
                },
                {
                    label: 'إضافة زبون',
                    icon: 'pi pi-user-plus',
                    class: extraMenuItemsAdded.value.find(i => i.key === 'add_customer') ? 'selected' : '',
                    command: () => addItemToNav('add_customer')
                },
                {
                    label: 'إضافة تاجر',
                    icon: 'pi pi-user-plus',
                    class: extraMenuItemsAdded.value.find(i => i.key === 'add_trader') ? 'selected' : '',
                    command: () => addItemToNav('add_trader')
                },
                {
                    label: 'تغيير الاسعار',
                    icon: 'pi pi-money-bill',
                    class: extraMenuItemsAdded.value.find(i => i.key === 'add_prices') ? 'selected' : '',
                    command: () => addItemToNav('add_prices')
                },
                {
                    label: 'الارصدة',
                    icon: 'pi pi-briefcase',
                    class: extraMenuItemsAdded.value.find(i => i.key === 'add_balances') ? 'selected' : '',
                    command: () => addItemToNav('add_balances')
                },
                {
                    label: 'تسجيل الخروج',
                    icon: 'pi pi-sign-out',
                    class: extraMenuItemsAdded.value.find(i => i.key === 'add_sign_out') ? 'selected' : '',
                    command: () => addItemToNav('add_sign_out')
                }
            ].filter(i => i)
        }
    ].filter(i => i));

    const addItemToNav = (key: String) => {
        store.toggleNavbarButton(key);
    };
</script>
